<template>
    <tr>
        <td colspan="5" style="padding-left: 20px">
            <table id="dnp_table" class="campaign-subselection-table">
                <thead>
                    <tr>
                        <th>{{ $t('Table View') }}</th>
                        <th>{{ $t('Reference Table') }}</th>
                        <th style="min-width: 120px">{{ $t('Mapped Column') }}</th>
                        <th>{{ $t('Reference Table Column') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(viewId, viewIndex) in viewIds">
                        <tr v-if="!(viewId in item.doNotProcess)" :class="`view-${viewIndex}-rule`">
                            <td class="primary">{{ getViewName(viewId) }}</td>
                            <td>
                                <CicSelect
                                    :options="tables.map(({ id, name }) => ({ value: id, label: name }))"
                                    :placeholder="$t('Select Table')"
                                    @input="(val) => addRule(viewId, val)"
                                />
                            </td>
                            <td>{{ $t('N/A') }}</td>
                            <td>{{ $t('N/A') }}</td>
                            <td colspan="2"></td>
                        </tr>
                        <template v-else>
                            <tr v-for="(dnpRule, index) in item.doNotProcess[viewId]" :class="`view-${viewIndex}-rule`">
                                <td class="primary">{{ getViewName(viewId, index) }}</td>
                                <td>
                                    <CicSelect
                                        :options="tables.map(({ id, name }) => ({ value: id, label: name }))"
                                        :value="dnpRule.tableId"
                                        @input="(val) => updateFieldValue(viewId, index, 'tableId', val)"
                                    />
                                </td>
                                <td>
                                    <CicSelect
                                        :options="
                                            Object.keys(viewColumns).map((column) => ({
                                                value: column,
                                                label: $t(viewColumns[column]),
                                            }))
                                        "
                                        :value="dnpRule.viewColumn"
                                        @input="(val) => updateFieldValue(viewId, index, 'viewColumn', val)"
                                    />
                                </td>
                                <td>
                                    <CicSelect
                                        :options="tableColumns[`t${dnpRule.tableId}`] ?? []"
                                        :value="dnpRule.referenceColumnId"
                                        @input="(val) => updateFieldValue(viewId, index, 'referenceColumnId', val)"
                                    />
                                </td>
                                <td style="padding: 0">
                                    <icon-button icon="remove-icon" @click="removeRule(viewId, index)" />
                                </td>
                            </tr>
                            <tr
                                v-if="item.doNotProcess[viewId].length < MAX_RULES_PER_VIEW"
                                :class="`view-${viewIndex}-rule`"
                            >
                                <td colspan="4"></td>
                                <td style="padding: 0">
                                    <icon-button icon="add-icon" @click="addRule(viewId)" />
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import IconButton from '@/components/controls/IconButton';
    import { post } from '@/utils/Http';

    export default {
        name: 'EditDoNotProcess',
        components: {
            CicSelect,
            IconButton,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            tables: {
                type: Array,
                required: true,
            },
            views: {
                type: Array,
                required: true,
            },
            viewIds: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        data() {
            return {
                MAX_RULES_PER_VIEW: 3,
                tableColumns: {},
                viewColumns: {
                    Name: 'Name',
                    Number: 'Number',
                    'Email Address': 'Email Address',
                    szMisc1: 'Misc 1',
                    szMisc2: 'Misc 2',
                    szMisc3: 'Misc 3',
                    szMisc4: 'Misc 4',
                    szMisc5: 'Misc 5',
                    szMisc6: 'Misc 6',
                    szMisc7: 'Misc 7',
                    szMisc8: 'Misc 8',
                    szMisc9: 'Misc 9',
                    szMisc10: 'Misc 10',
                    szMisc11: 'Misc 11',
                    szMisc12: 'Misc 12',
                    szMisc13: 'Misc 13',
                    szMisc14: 'Misc 14',
                    szMisc15: 'Misc 15',
                    szMisc16: 'Misc 16',
                    szMisc17: 'Misc 17',
                    szMisc18: 'Misc 18',
                    szMisc19: 'Misc 19',
                    szMisc20: 'Misc 20',
                },
            };
        },
        created() {
            const tableIds = [];
            Object.values(this.item.doNotProcess).forEach((dnpRules) => {
                dnpRules.forEach((dnpRule) => {
                    if (dnpRule.tableId) {
                        tableIds.push(dnpRule.tableId);
                    }
                });
            });
            this.loadColumns(tableIds);
        },
        methods: {
            addRule(viewId, tableId = null) {
                let doNotProcess = JSON.parse(JSON.stringify(this.item.doNotProcess));
                if (Array.isArray(doNotProcess)) {
                    doNotProcess = {};
                }
                if (viewId in doNotProcess) {
                    doNotProcess[String(viewId)].push({ referenceColumnId: null, tableId, viewColumn: 'Name' });
                } else {
                    doNotProcess[String(viewId)] = [{ referenceColumnId: null, tableId, viewColumn: 'Name' }];
                }

                this.$emit('change', doNotProcess);
            },
            loadColumns(tableIds) {
                if (tableIds.length === 0) {
                    return;
                }

                post('campaign/gettablecolumns', { tableIds }, ({ tables }) => {
                    tables.forEach((table) => {
                        this.tableColumns[`t${table.tableId}`] = table.columns.map(({ id, name }) => ({
                            value: id,
                            label: name,
                        }));
                    });
                });
            },
            getViewName(id, index = 0) {
                let view;
                if (index === 0) {
                    view = this.views.find(({ viewId }) => viewId === id);
                }

                return view ? view.name : '';
            },

            removeRule(viewId, index) {
                let doNotProcess = JSON.parse(JSON.stringify(this.item.doNotProcess));
                doNotProcess[viewId].splice(index, 1);
                if (doNotProcess[viewId].length === 0) {
                    delete doNotProcess[viewId];
                }
                this.$emit('change', doNotProcess);
            },

            updateFieldValue(viewId, index, name, value) {
                let doNotProcess = JSON.parse(JSON.stringify(this.item.doNotProcess));
                doNotProcess[viewId][index][name] = value;
                this.$emit('change', doNotProcess);

                if (name === 'tableId' && !this.tableColumns[`t${value}`]) {
                    this.loadColumns([value]);
                }
            },
        },
    };
</script>
